export const flatten = (obj: Record<string, any>, parentKey = "", res: Record<string, any> = {}) => {
	for (const key in obj) {
		const newKey = parentKey ? `${parentKey}.${key}` : key;
		if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
			flatten(obj[key], newKey, res);
		} else {
			res[newKey] = obj[key];
		}
	}
	console.log("");
	return res;
};

export const flattenFormData = (data: any, parentKey = "", result: Record<string, any> = {}) => {
	for (const key in data) {
		const value = data[key];
		const newKey = parentKey ? `${parentKey}.${key}` : key;

		if (value && typeof value === "object" && !Array.isArray(value) && !(value instanceof File)) {
			flattenFormData(value, newKey, result);
		} else {
			result[newKey] = value;
		}
	}

	return result;
};
